export default __webpack_public_path__ + "static/media/accessDenied.e3667404.svg";